import axios from "../AxiosInstance"



const loginAPI = async (data) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: `/api/auth/login`,
            method: "POST",
            data
        })
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }

    return resolved
}

const RegisterAPI = async (data) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: `/api/auth/register`,
            method: "POST",
            data
        })
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }

    return resolved
}

export { loginAPI, RegisterAPI }